import React from 'react';
import { Send } from 'lucide-react';
import { useEnquiryForm } from '../../hooks/useEnquiryForm';
import { useToast } from '../../hooks/use-toast';
import FormField, { inputClass } from './FormField';

export default function ContactForm() {
  const { toast } = useToast();
  const { form, errors, setField, submit } = useEnquiryForm(() => {
    toast({ title: 'Enquiry sent successfully', description: 'Our team will reach out to you shortly.' });
  });

  return (
    <div className="lg:col-span-3 rounded-3xl bg-white border border-[var(--pca-border)] p-7 md:p-9 shadow-[0_30px_60px_-30px_rgba(11,46,110,0.35)]">
      <h3 className="text-2xl font-extrabold text-[#0B2E6E]">Admission Enquiry</h3>
      <p className="text-slate-600 text-sm mt-1">Fill the form and our team will get back to you.</p>

      <form onSubmit={submit} className="mt-6 grid gap-4 sm:grid-cols-2">
        <FormField label="Full Name" error={errors.name}>
          <input
            value={form.name}
            onChange={(e) => setField('name', e.target.value)}
            className={inputClass(errors.name)}
            placeholder="Your full name"
          />
        </FormField>
        <FormField label="Email" error={errors.email}>
          <input
            value={form.email}
            onChange={(e) => setField('email', e.target.value)}
            className={inputClass(errors.email)}
            placeholder="you@example.com"
          />
        </FormField>
        <FormField label="Phone" error={errors.phone}>
          <input
            value={form.phone}
            onChange={(e) => setField('phone', e.target.value)}
            className={inputClass(errors.phone)}
            placeholder="+91 98xxxxxxxx"
          />
        </FormField>
        <FormField label="Interested Course">
          <select
            value={form.course}
            onChange={(e) => setField('course', e.target.value)}
            className={inputClass(false)}
          >
            <option>B.Pharm</option>
            <option>D.Pharm</option>
          </select>
        </FormField>
        <div className="sm:col-span-2">
          <FormField label="Message">
            <textarea
              rows="4"
              value={form.message}
              onChange={(e) => setField('message', e.target.value)}
              className={inputClass(false)}
              placeholder="Tell us how we can help..."
            />
          </FormField>
        </div>
        <div className="sm:col-span-2">
          <button type="submit" className="btn-primary">
            Send Enquiry <Send size={16} />
          </button>
        </div>
      </form>
    </div>
  );
}
